import styled from '@emotion/styled'
import Card from '@mui/material/Card'
import { node, string } from 'prop-types'
import { alertColors } from '@global/constants'

const Warning = styled.div`
  background-color: ${({ color }) => color};
  width: 16px;
`

const Padding = styled.div`
  padding: 16px;
`

const StyledCard = styled(Card)`
  display: inline-flex;
`

export const CvsAlert = ({ children, level = 'warning' }) => {
  return (
    <StyledCard>
      <Warning color={alertColors[level]} />
      <Padding>{children}</Padding>
    </StyledCard>
  )
}

CvsAlert.propTypes = {
  children: node.isRequired,
  level: string,
}
